module.exports = __webpack_public_path__ + "media/Menu Choice.d22ba884.mp3";